export { default as Backorders } from "./IndexPage/Backorders.vue";
